import { post, postJson, deleteApi, put, get, imagePost, putJson,postBlob } from './axios3'

import { putOne , postJsonBlob} from './axios2'

const RESOURCE_BASE_PATH = '/paradiseAndTaskCommon';

const RESOURCE_BASE_PATH2 = '/pointsExchange';

const RESOURCE_BASE_PATH3 = '/image';

const RESOURCE_BASE_PATH4 = '/PointActivityAnalyticController';

const RESOURCE_BASE_PATH5 = '/bigTurntableDraw';

const RESOURCE_BASE_PATH6 = '/order-lottery';

// 积分锁权
const RESOURCE_BASE_PATH7 = '/lockRight';

// 分页获取活动列表(积分任务和积分乐园)
export const taskList = p => postJson(`${RESOURCE_BASE_PATH}/list`, p);

// 获取活动域名
export const prefixurl = p => get(`${RESOURCE_BASE_PATH}/prefixurl`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)  
export const exchangeActivityList = p => postJson(`${RESOURCE_BASE_PATH2}/exchangeActivityList`, p);

//积分中心-积分商城-兑换记录 
export const getExchangeActivityRecord = p => postJson(`/PointActivityAnalyticController/getExchangeActivityRecord`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)
export const setActivityList = p => postJson(`${RESOURCE_BASE_PATH2}`, p);

// 查询礼品兑换活动列表(兑换优惠券和兑换实物)
export const setActivityVenderType = p => postJson(`${RESOURCE_BASE_PATH2}`, p);

// 创建礼品兑换活动-京豆
export const setActivityListBean = p => postJson(`${RESOURCE_BASE_PATH2}`, p);

// 查询礼品兑换活动详情(兑换优惠券和兑换实物)
export const getPointsExchange = p => get(`/pointsExchange/`+p);


// 删除礼品兑换活动列表(兑换优惠券和兑换实物)
export const deleteActivityList = id => deleteApi(`${RESOURCE_BASE_PATH2}/${id}`);

// 查询详情
export const inquireActivity = id => get(`${RESOURCE_BASE_PATH2}/${id}`);

// 修改详情
export const changeActivity = p => put(`${RESOURCE_BASE_PATH2}`, p);

// 上架下架礼品兑换
export const updateActivityList = p => put(`${RESOURCE_BASE_PATH2}/status/${p.id}?status=${p.status}`);

// 上传图片
export const uploadpic = p => imagePost(`${RESOURCE_BASE_PATH3}/upload`, p);

//标记发货
export const changeStatus = id => post(`${RESOURCE_BASE_PATH4}/markDeliveryStatus?id=${id}`);

//幸运抽奖
export const bigTurntableDraw = p => postJson(`${RESOURCE_BASE_PATH5}`, p);

//修改幸运抽奖
export const modifyBigTurn = p => putOne(`${RESOURCE_BASE_PATH5}`, p);

//幸运抽奖详情
export const getbigTurn = id => get(`${RESOURCE_BASE_PATH5}/${id}`);

//积分锁权 创建
export const addLockRight = p => postJson(`${RESOURCE_BASE_PATH7}/createActivity`, p);

//积分锁权 修改
export const modifyLockRight = p => putOne(`${RESOURCE_BASE_PATH7}/updateActivity`, p);

//积分锁权 详情
export const getLockRight = id => get(`${RESOURCE_BASE_PATH7}/detail/${id}`);

//下单有礼
export const bigTurntableDraw2 = p => postJson(`${RESOURCE_BASE_PATH6}/save`, p);
//下单有礼详情
export const getOrderDraw = id => get(`${RESOURCE_BASE_PATH6}/get/${id}`);

//  人群
export const getPersonLabelList = id => get(`/giftBag/getPersonLabelList`);

// 创建开卡礼包
export const createShopGift = p => postJson(`/giftBag/createShopGift`,p);

// 获取礼包活动下单转化数据
export const getShopGif = p => get(`/giftBag/getShopGiftParticipateConver`,p);


// 获取礼包模板列表数据
export const getGiftBagTemplate = p => get(`/giftBag/getGiftBagTemplate`,p);
// 获取礼包模板列表数据 分类 开卡 店铺 千人千面
export const getGiftBagList = p => get(`/giftBag/dir/list/${p}`);

// 修改礼包
export const editShopGift = p => postJson(`/giftBag/editShopGift`,p);

// 修改进行中的礼包
export const newupdateCommon = p => postJson(`/paradiseAndTaskCommon/activity/updateCommon`,p);

// 获取x详情   /jd-yusms-admin/giftbag/template/page
export const giftBagEide = id => get(`/giftBag/${id}`);

export const getValidActivity = p => get(`/giftBag/getValidActivity`)

// 创建店铺礼包千人千面
export const createThousandGift = p => postJson(`/giftBag/createThousandGift`, p);

// 修改店铺礼包千人千面
export const editThousandGift = p => postJson(`/giftBag/editThousandGift`, p);

// 千人千面  查询 
export const thousandGiftDetail = id => get(`/giftBag/thousandGiftDetail/${id}`)

//首购 复购 下单有礼 创建
export const createPurchaseActivity = p => postJson(`/purchaseActivity/create`, p);

// 首购 复购 下单有礼  查询 
export const purchaseActivityDetail = id => get(`/purchaseActivity/${id}`,)

// 首购 复购 下单有礼  修改 
export const editPurchaseActivity = p => putOne(`/purchaseActivity/edit`,p)

// 云短信过期时间
export const publicOpen = id => get(`/public/open/jd-crm`,)

// 创建评价有礼任务
export const commentCreate = p => postJson(`/comment/create`, p)

// 查询 评价有礼任务
export const getComment = id => get(`/comment/${id}`,)

//评价有礼任务 修改 
export const editCommentCreate = p => putOne(`/comment/edit`, p)

// 创建 裂变任务
export const splitCouponCreate = p => postJson(`/splitCoupon/save`, p)

// 查询 裂变任务
export const getSplitCoupon = id => get(`/splitCoupon/${id}`,)

//裂变任务 修改 
export const editSplitCoupon = p => postJson(`/splitCoupon/edit`,p)

// 创建 红包雨任务
export const redPacketCreate = p => postJson(`/red_packet_rain/save`, p)

// 查询 红包雨任务
export const getredPacket = id => get(`/red_packet_rain/details/${id}`,)


// 创建 抓娃娃  大家来找茬任务
export const createGameHub = p => postJson(`/gameHub/create`, p)

// 修改 抓娃娃  大家来找茬任务
export const editGameHub = p => putJson(`/gameHub/edit`, p)

// 查询 抓娃娃  大家来找茬任务
export const getGameHub = id => get(`/gameHub/${id}`,)

// 查询 大家一起来找擦模板集合/jd-hd-web/
export const getGameTemplate = id => get(`/gameHub/gameTemplate`,)

// 创建 创建预售有礼活动
export const createPresell = p => postJson(`/presell-activity/create`, p)

// 编辑 创建预售有礼活动/jd-hd-web/presell-activity/{id}
export const editPresell = p => postJson(`/presell-activity/edit`, p)

// 详情 预售有礼活动/jd-hd-web/
export const getPresell = p => get(`/presell-activity/${p}`)

// 创建 创建预售抽奖/jd-hd-web/
export const getlottery= p => get(`/presell-lottery/get/${p}`)

// 创建 创建预售抽奖/
export const createlottery = p => postJson(`/presell-lottery/save`, p)

// /jd-point/pointsExchange/{type}/{itemId}
export const hdTaskTemplateGroup = p => get(`/suspendingIcon/hdTask/getSystemTemplateGroup`, p)

// 创建E卡
export const pointsEcard = p => postJson(`/pointsExchange/ecard`, p)

// 创建京豆
export const pointsBean = p => postJson(`/pointsExchange/bean`, p)

// 查总数
export const pointsExchange = p => get(`/pointsExchange/${p.type}/${p.itemId}`,)

// 查总数京豆
export const accountBalance = p => get(`/beansPlan/accountBalance`,)
export const accountBalance2 = p => get(`/beansPlan/accountBalance`,p)
// 刮刮乐
export const saveScratchers = p => postJson(`/scratchers/saveOrUpdate`, p)
// 刮刮乐详情
export const editScratchers = p => get(`/scratchers/${p}`)
// 海报/
export const saveSmartPost = p => postJson(`/smart-post/saveOrUpdate`, p)

// 海报详情/jd-hd-web/
export const editSmartPost = p => get(`/smart-post/${p}`)

// id查活动时间
export const getActivityInfoFromUrl = p => get(`/smart-post/getActivityInfoFromUrl/`,p)

//海报刮刮图片分类
export const getSystemTemplateGroup = id => get(`/suspendingIcon/smartCard/getSystemTemplateGroup`, id)
//海报刮刮图片图片
export const sellerImage = p => postJson(`/sellerImage/list`, p)

//海报刮刮图片图片
export const zdImage = p => postJson(`/sellerImage`, p)

export const getmoble = p => get(`/seller/current`, p);

export const getSellerCheckCode = p => get(`/seller/getSellerCheckCode`,p);

export const exportRecord = p => postBlob(`/jd-hd-web/PointActivityAnalyticController/exportExchangeActivityRecord`, p)

//派样付款列表随单发
export const expotrPromoSendReBuy = p => postBlob(`/jd-hd-web/promoSendReBuy/payOrder/export`, p)

//令牌赠品发放记录导出
export const expotrPromoSendReBuytokenRecord = p => postBlob(`/jd-hd-web/promoSendReBuy/tokenRecord/export`, p)

//派样回购对标商品导出
export const benchmarkingExport = p => postBlob(`/jd-hd-web/promoSendReBuy/benchmarking/export`, p)

export const memberImproveRecords = p => postBlob(`/jd-hd-web/PointActivityEffectDetails/memberImproveRecords/export`, p)


export const activityDetail = p => get(`/paradiseAndTaskCommon/activity/detail`, p);

export const exportBatch = p => postBlob(`/jd-hd-web/pointsExchange/exportBatch`, p)


// 获取超级裂变券活动详情
export const editSplitSuper = p => get(`/super-splitCoupon/${p}`)
// 创建超级裂变券活动
export const SplitSuperSave = p => postJson(`/super-splitCoupon/save`, p)

// 修改超级裂变券活动
export const SplitSuperEdit = p => putJson(`/super-splitCoupon/edit`, p)

// 获取用户身份列表
export const getInviteeTypes = p => get(`/super-splitCoupon/getInviteeTypes`)

// 保存修改活动-会员卡片
export const memberCardSave = p => postJson(`/memberCard/saveOrUpdate`, p)
// 详情接口-会员卡片
export const memberCardList = p => get(`/memberCard/${p}`)
// 保存修改活动-会员卡片
export const freeTrialSave = p => postJson(`/freeTrial/saveOrUpdate`, p)
// 详情接口-会员卡片
export const freeTrialCardList = p => get(`/freeTrial/${p}`)


//下单冲榜---start

//创建活动接口
export const createOrderRank = p => postJson(`/order-rank/create`, p)

//查询 
export const orderRankDetail = id => get(`/order-rank/detail/${id}`,)

//修改 
export const updateOrderRank = p => putOne(`/order-rank/update`,p)

//---end


//红包兑换---start

//创建红包兑换活动接口
export const createRedPacket = p => postJson(`/pointsExchange/redPacket`, p)

// 创建生日有礼活动
export const createBirthDayGift = p => postJson(`/BirthDayGiftController/createBirthDayGift`, p)

// 编辑生日有礼活动
export const updateBirthDayGift = p => postJson(`/BirthDayGiftController/updateBirthDayGift`, p)

// 生日有礼活动详情
export const getBirthDayDetail = id => get(`/BirthDayGiftController/detail/${id}`)

// 生日有礼-实物奖品中奖名单
export const goodRecords = p => get(`/PointActivityEffectDetails/goodRecords`,p)

// 会员商城-活动列表-修改兑换活动接口
export const updateActivity = p => postJson(`/pointsExchange/updateActivity`, p)

// 会员商城-活动列表-保存商城模板接口
export const saveEchange = p => postJson(`/decorationInfo/exchange`, p)

// 会员商城-活动列表-查询商城装修模板
export const getDecorationInfoDetail = p => get(`/decorationInfo/exchange/detail`, p)

// 活动管理-中奖查询-根据pin获取中奖记录
export const getWinRecordByPin = p => postJson(`/pointActivity/getWinRecordByPin`, p)


// 创建会员升级礼活动
export const saveMemberLevelGift = p => postJson(`/memberLevelGift/save`, p)

// 获取会员升级礼活动
export const getMemberLevelGift = id => get(`/memberLevelGift/detail/${id}`)

// 获取会员等级权益
export const getMemberBenefitInfo = p => postJson(`/memberBenefit/getMemberBenefitInfo`, p)

// 创建会员权益
export const createMemberBenefitInfo = p => postJson(`/memberBenefit/createMemberBenefitInfo`, p)

// 删除会员权益
export const deleteMemberBenefitInfo = id => postJson(`/memberBenefit/delete/deleteMemberBenefitInfo?id=${id}`)

// 会员升级礼参与记录导出
export const exportGiftRecord = p => postJsonBlob(`/jd-hd-web/memberLevelGift/exportGiftRecord`,p)

/**
 * 情书贺卡相关接口
 */

// 创建/更新 情书贺卡活动
export const saveBilletDoux = p => postJson(`/LoveLetterGreetingCardController/saveActivity`, p)

// 获取情书贺卡活动详情
export const getBilletDouxDetail = id => get(`/LoveLetterGreetingCardController/detail/${id}`)

// 情书贺卡参与记录导出
export const exportBilletDetail  = p => postJsonBlob(`/jd-hd-web/LoveLetterGreetingCardController/participants/platform-export`,p)

// 情书贺卡获取记录导出
export const exportBilletReceive = p => postJsonBlob(`/jd-hd-web/LoveLetterGreetingCardController/acquisition/platform-export`,p)

// 实物名单-订单明细
export const getOrderRrankorderDetail = p => get('/order-rank/orderDetail',p)

// 创建兑换活动(爱奇艺会员、京东plus、礼品卡、百度网盘)
export const createPointsExchangeGift = p => postJson('/pointsExchange/gift',p)